module.exports = __webpack_public_path__ + "static/media/reference-slider-21.a0fee351.jpg";